import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import LoadingPage from '../LoadingPage';
import ModalTable from './ModalTable';
import Api from '../../services/ApiService';
import ModalContext from './ModalContext';

const MAX_LENGTH = 25;

const ModalTableContainer = ({ view, lookupKey, branchId, title }) => {
  const [data, setData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [loading, setLoading] = useState(true);
  const { setTitle } = useContext(ModalContext);

  const getData = () => {
    setLoading(true);

    const query = branchId !== undefined ? `?branchId=${branchId}` : '';

    Api.get(`drilldown/${view}/${encodeURIComponent(lookupKey)}${query}`).then(response => {
      const { data, headers } = response.data;
      const id = lookupKey.length > MAX_LENGTH ? `${lookupKey.substring(0, MAX_LENGTH)}...` : lookupKey;
      setData(data);
      setHeaders(headers);
      setLoading(false);
      setTitle(`${title} (${id.replace('!!:!!', ', ')})`);
    });
  };

  useEffect(() => {
    getData();
  }, []);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="modal-table-container">
      <ModalTable data={data} headers={headers} />
    </div>
  );
};

ModalTableContainer.propTypes = {
  branchId: PropTypes.string,
  lookupKey: PropTypes.string,
  title: PropTypes.string,
  view: PropTypes.string,
};

export default ModalTableContainer;
